module.exports = __webpack_public_path__ + "static/img/mb-smart-land-big.734d585f.jpg";